import React, {useState, useEffect} from 'react';

import Popup from '../partials/OLIPopup.js';
import AudioPlayer from '../UI/AudioPlayer.js';
import globals from '../../globals.json';

const DynamicPager = props => {
    const [showPopup, setShowPopup] = useState(false);
    const [showAudioControls, setShowAudioControls] = useState(true)
    useEffect(() => {
        // console.log(props.data.popup !== undefined)
        if (props.data.popup !== undefined) {
            setShowPopup(true);
            // console.log(props.data.popup.audio !== undefined)
            if (props.data.popup.audio !== undefined) {
                setTimeout(() => {
                    props.audioController.playAudioByName(props.data.popup.audio);
                }, 500);
            }
        } else {
            props.audioController.playAudioByName(props.data.audio);
        }
        return () => {
            // audio cleanup
            props.audioController.removeAudio(props.data.audio);
            if (props.data.popup) {
                props.audioController.removeAudio(props.data.popup.audio);
            }
        }
    }, [])

    const popupOnClick = () => {
        props.audioController.removeAudio(props.data.popup.audio);
        props.audioController.playAudioByName(props.data.audio);
        setShowPopup(false)
    }

    const continueOnClick = () => {
        props.audioController.removeAudio(props.data.audio);
        props.onComplete()
    }

    return (
        <div className={`DynamicPager ${props.data.class}`}>
            {props.data.audio &&
                <AudioPlayer audioController={props.audioController} audioCollection={props.audioCollection} />}
            {props.data.topRightOrange &&
                <div className={`top-right-orange ${!showPopup ? 'slide-left' : ''}`} />
            }
            {props.data.bottomLeftOrange &&
                <div className={`bottom-left-orange ${!showPopup ? 'slide-right' : ''}`} />
            }
            <div className={`sections`}>
                {
                    props.data.sections && props.data.sections.map((e,i) => {
                        return (
                            <div key={`sec-${i}`} className={`section section-${i}`}>
                                <div className={`header ${showPopup ? '' : 'post-popup'}`} dangerouslySetInnerHTML={{__html: e.header || ''}} />
                                <div className={`yellow-underline ${showPopup ? '' : 'post-popup'}`} />
                                <div className={`body ${showPopup ? '' : 'post-popup'}`} dangerouslySetInnerHTML={{__html: e.body}} />
                            </div>
                        )
                    })
                }

            </div>
            <div className={`extra-image ${showPopup ? '' : 'post-popup'}`} />
            {showPopup && 
                <Popup data={props.data.popup} onComplete={popupOnClick} />
            }
            <div className={`global-button button ${showPopup ? '' : 'post-popup'}`} onClick={continueOnClick}>{globals.continueButtonText}</div>
        </div>
    )
}



export default DynamicPager